import { currencyOptions } from '~/domains/taxonomies/types'

export const convertCurrencyForDisplay = (
  amount?: number | null,
  currency?: number | null
) => {
  if (!amount) return null
  const currencyOption = currencyOptions.find((c) => c.id === currency)
  return amount / (currencyOption?.factor ?? 1)
}

export const computeAmountWithCurrency = (
  amount?: number | null,
  currency?: number | null
) => {
  if (!amount) return null
  const currencyOption = currencyOptions.find((c) => c.id === currency)
  return amount * (currencyOption?.factor ?? 1)
}

export const formatCurrency = (amount: number, currency?: number | null) => {
  const currencyOption = currencyOptions.find((c) => c.id === currency)
  return `${convertCurrencyForDisplay(amount, currency)} ${currencyOption?.name ?? '€'}`
}
